import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized-layout',
  imports: [],
  templateUrl: './unauthorized-layout.component.html',
  styleUrl: './unauthorized-layout.component.scss',
  host: {
    class: 'h-100 app-layout app-layout-unauthorized',
  },
})
export class UnauthorizedLayoutComponent {}
